import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Socket, SocketIoConfig } from 'ngx-socket-io';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private socketUrl: string = '';

  constructor(private http: HttpClient) {}

  async loadConfig() {
    try {
      const response: any = await firstValueFrom(this.http.get('https://chat.ivydental.com.tw/php/socket_url.php'));
      this.socketUrl = response;
    } catch (error) {
      console.error('Error fetching socket URL:', error);
    }
  }

  getSocketUrl(): string {
    return this.socketUrl;
  }
  
  createSocket(): Socket {
    const socketConfig: SocketIoConfig = {
      url: this.socketUrl,
      options: {
        autoConnect: false,
        transports: ['websocket', 'polling'],
        upgrade: true,
        timeout: 7000,
        reconnection: true,
        reconnectionAttempts: 8,
        reconnectionDelay: 800,
        reconnectionDelayMax: 4000,
        randomizationFactor: 0.5,
      },
    };
    return new Socket(socketConfig);
  }
}
